<template>
    <!-- 质量原因组件 纯展示组件 -->
    <div v-if="quality">
        <mc-tag
            theme="orange"
            :type="qualityType"
        >
            {{ qualityType ? '不符合原因' : '加分项' }}
        </mc-tag>

        <mc-tag
            theme="orange"
            type="unbordered"
        >
            {{ quality }}
        </mc-tag>
    </div>
</template>

<script setup>
import { computed } from '@vue/composition-api';

export default {
    name: 'SgExtAttrWrap',
    props: {
        // 质量原因
        qualityList: {
            type: Array,
            default: () => ([]),
        },
        qualityType: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const quality = computed(() => (props.qualityList || []).join(','));

        return {
            quality,
        };
    },
};
</script>
